import client from './http';

const configForm = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const getSearchedPayment = query => client.get(`payments/${query}`, config);
export const getSearchedPaymentTransaction = query => client.get(`paymenttransactions/${query}`, config);
export const sendPayment = (id, paymentId, data) => client.post(`pos/${id}/payment/paymenttransactions/${paymentId}/sendPayment/`, data, configForm);
export const sendPaymentDue = (id, data) => {
  data.fullResponse = true; // eslint-disable-line
  return client.patch(`pos/${id}/`, data, config);
};
export const confirmPayment = (poId, paymentId, data) => {
  data.fullResponse = true; //eslint-disable-line
  return client.post(`pos/${poId}/payment/paymenttransactions/${paymentId}/ackPayment/`, data, config);
};
export const rejectPayment = (poId, paymentId, data) => {
  data.fullResponse = true; //eslint-disable-line
  return client.post(`pos/${poId}/payment/paymenttransactions/${paymentId}/rejectPayment/`, data, config);
};

export const resetPayment = (poId, paymentId) => client.post(`pos/${poId}/payment/paymenttransactions/${paymentId}/resetConfirmation/`, { fullResponse: true }, config);



// WEBPACK FOOTER //
// ./src/services/payments.js